import { ActionPermissions } from '../../@types';
import { isUserHasPermission, PermissionInput } from '../../configs/permissions';

/**
 * May this user act on many jobs at once?
 *
 * Both halves are required deliberately. `isUserHasPermission` is
 * hierarchical, so `service.bulkUpdate` alone is satisfied by any
 * `service.bulkUpdate.*` child — someone holding only `fileUpload` would pass
 * it. Pairing it with `editService` is what makes this a real gate.
 */
export const canBulkUpdateJobs = (permissions: PermissionInput[] | null | undefined): boolean =>
  isUserHasPermission(ActionPermissions.Service_Bulk_Update, permissions) &&
  isUserHasPermission(ActionPermissions.Service_Bulk_Update_Edit_Service, permissions);

/**
 * May this user change status across many jobs? A bulk status change bypasses
 * interaction forms outright, so it needs the status-change permission on top
 * of the bulk gate.
 */
export const canBulkStatusJobs = (permissions: PermissionInput[] | null | undefined): boolean =>
  canBulkUpdateJobs(permissions) &&
  isUserHasPermission(ActionPermissions.Service_Edit_Status_Progress_Status_Change, permissions);
